// extracted by mini-css-extract-plugin
export var bodyContainer = "vovOS";
export var header = "MQxwk";